import FaqContainer from '../partialComponents/FaqContainer'
import BasicTemplate from '../templates/BasicTemplate'
import { faqs } from '../utils/faqs'
import StateBenefits from '../partialComponents/StateBenefits'
import { benefits } from '../utils/benefits'
import Academic from '../utils/academic'
import StateCbseHero from '../partialComponents/StateCbseHero'
import StateCbseGrains from '../partialComponents/StateCbseGrains'
import HelmetGenerator from '../partialComponents/HelmetGenerator'
import { helmets } from '../utils/helmets'
import { useEffect } from 'react'
import GetStarted from '../partialComponents/GetStarted'
import stateWave from '../../Assets/layout_images/stateWave.png'
import { whoCanBenefit } from '../utils/whoCanBenefit'
import WhoCanBenefitHeptagon from '../partialComponents/WhoCanBenefitHeptagon'
import { useLocation } from 'react-router'
import Steps from '../partialComponents/steps'
import FeesComparision from './feescomparision'
import StudentTestimonials from '../partialComponents/StudentTestimonials'

export default function Cbse() {
    const location = useLocation()
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [location])
    return (
        <>
            <HelmetGenerator details={helmets.cbse} />
            <BasicTemplate>
                <div className="state_page_section">
                    <StateCbseHero cbse={true} />

                    <StateCbseGrains />

                    <StateBenefits benefits={benefits.cbse} />
                    <WhoCanBenefitHeptagon
                        page={'state'}
                        waveTop={stateWave}
                        whoCanBenefits={whoCanBenefit.state}
                    />
                    <Steps type={'state'} color={'#4394F7'} />
                    <FeesComparision/>
                    <div className="home_section">  
                    <StudentTestimonials />
                    </div>

                    <FaqContainer faqList={faqs.cbse} />
                </div>
            </BasicTemplate>
        </>
    )
}
